import { createContext, useContext } from 'react';
import type { CampaignOfferPayload } from './campaignOfferCopy';

export const EMPTY_CAMPAIGN_OFFERS: CampaignOfferPayload = {
  offers: [],
  offerKey: '',
  popupDismissed: true,
};

export type CampaignBonusOffersValue = CampaignOfferPayload & {
  dismissPopup: () => Promise<void>;
};

export const CampaignBonusOffersContext = createContext<CampaignBonusOffersValue>({
  ...EMPTY_CAMPAIGN_OFFERS,
  dismissPopup: async () => {},
});

export function useCampaignBonusOffers() {
  return useContext(CampaignBonusOffersContext);
}
